export default "__VITE_ASSET__Bo8KDe2l__"